export default {
  common: {
    nameApp: 'ATTENDANCE BOARD',
    ok: 'OK',
    cancel: 'キャンセル',
  },
  login: {
    title: '管理者ログイン',
    username: {
      label: 'ログインID',
      placeholder: 'メールアドレスを入力',
    },
    password: {
      label: 'パスワード',
      placeholder: 'パスワードを入力',
    },
    submit: 'ログイン',
  },
  setting: {
    logout: 'ログアウト',
    db: 'DB指定・管理',
    app_config: 'APP認証',
    db_config: 'DBの選択',
    app_id: {
      label: 'APP ID',
      placeholder: 'APP IDを入力してください',
    },
    app_key: {
      label: 'APIキー',
      placeholder: 'APIキーを入力してください',
    },
    next: '次へ',
    private_db: {
      label: 'Private DB',
      placeholder: 'Private DBを選択してください',
    },
    back: '戻る',
    finish: '完了',
    no_options: 'オプションなし',
    url: {
      label: 'URL',
      placeholder: 'URLを入力してください',
      errorMessage: '正しい形式でURLを入力してください。',
    },
    db_id: {
      label: 'DB ID',
      placeholder: 'DB IDを入力してください',
    },
    db_key: {
      label: 'DBキー',
      placeholder: 'DBキーを入力してください',
    },
  },
  home: {
    reset: 'リセット',
    setDb: 'Private DBの指定',
    settingDb: 'DB設定',
    threshold: '閾値設定',
    thresholdValue: '閾値設定({{0}})',
    absenceTime: '不在判定時間',
    timeMinutes: '不在判定時間({{0}}分)',
    contentModalResetData: 'データーをリセットします。よろしいでしょうか。',
    contentModalSettingDb: '設定画面に戻ります。よろしいでしょうか。',
    absenceTimeMinutes: {
      label: '不在判定時間(分)',
      placeholder: '不在判定時間(分)を入力してください',
    },
  },
  message_error: {
    app_config: '入力したAPP IDまたはAPPキー、またはDB IDまたはDBキーが正しくありません。',
    internal_server:
      'サーバーでエラーが発生しました。管理者に問い合わせてください。',
    key_config: '入力したまたはDB IDまたはDBキーが正しくありません。',
  },
};
